import React, { useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import Icon from '../../../base/icons/components/Icon';
import { EmptyPolls } from '../../../base/icons/svg';
import { withPixelLineHeight } from '../../../base/styles/functions.web';
import PollItem from './PollItem';
const useStyles = makeStyles()(theme => {
    return {
        container: {
            height: '100%',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
        },
        emptyIcon: {
            width: '174px',
            '& svg': {
                width: '100%',
                height: 'auto'
            }
        },
        emptyMessage: {
            ...withPixelLineHeight(theme.typography.bodyLongBold),
            color: theme.palette.text02,
            padding: '0 24px',
            textAlign: 'center'
        }
    };
});
const PollsList = ({ setCreateMode }) => {
    const { t } = useTranslation();
    const { classes, theme } = useStyles();
    const { polls } = useSelector((state) => state['features/polls']);
    const pollListEndRef = useRef(null);
    const scrollToBottom = useCallback(() => {
        if (pollListEndRef.current) {
            const param = {
                behavior: 'smooth',
                block: 'end',
                inline: 'nearest'
            };
            pollListEndRef.current.scrollIntoView(param);
        }
    }, [pollListEndRef.current]);
    useEffect(() => {
        setTimeout(() => {
            scrollToBottom();
        }, 100);
    }, [Object.keys(polls).length]);
    const listPolls = Object.keys(polls);
    return (
    // <div>
    //     {JSON.stringify(polls)}
    //     </div>
    React.createElement(React.Fragment, null, listPolls.length === 0
        ? React.createElement("div", { className: classes.container },
            React.createElement(Icon, { className: classes.emptyIcon, color: theme.palette.icon03, src: EmptyPolls }))
        : listPolls.map((id, index) => (React.createElement(PollItem, { key: id, pollId: id, ref: listPolls.length - 1 === index ? pollListEndRef : null, setCreateMode: setCreateMode })))));
};
export default PollsList;
